import { Button, Input, Tooltip, Dropdown, Empty, Card, Form } from "antd";
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { Oval } from "react-loader-spinner";
import useAnnouncementHooks from "Hooks/AdminHooks/useAnnouncementHooks";

function Announcement() {
  const {
    submitting,
    isAdding,
    handleCancel,
    editMode,
    loading,
    announcements,
    menu,
    handleEditAnnouncement,
    handleSubmit,
    handleAddAnnouncement,
    truncateText,
    form,
  } = useAnnouncementHooks();

  return (
    <Card
      className="dash-card"
      style={{ height: "100%" }}
      title="Announcement"
      extra={
        !isAdding &&
        !editMode && (
          <Button
            type="default"
            className="add-announcement-button"
            onClick={handleAddAnnouncement}
          >
            Add Announcement
          </Button>
        )
      }
    >
      <div className="row">
        {loading ? (
          <div className="loading-container">
            <Oval height={40} width={40} color="#4fa94d" visible={true} />
          </div>
        ) : (
          <>
            {!isAdding && !editMode && (
              <div className="announcement-list" style={{ maxHeight: 250, overflowY: "auto", paddingRight: 6 }}>
                {announcements.length > 0 ? (
                  announcements.map((ann) => (
                    <div
                      key={ann.id ?? ann.announcementId ?? `${ann.title}-${ann.message}`}
                      className="announcement-container"
                    >
                      <FontAwesomeIcon icon={faInfoCircle} className="frame-icon" />
                      <div className="announcement-content">
                        <p className="announcement-text">
                          <Tooltip title={ann.title}>{truncateText(ann.title, 50)}</Tooltip>
                        </p>
                        <p className="message-text">
                          <Tooltip title={ann.message}>{truncateText(ann.message, 45)}</Tooltip>
                        </p>
                      </div>
                      <Dropdown menu={menu(ann)} placement="bottomRight">
                        <Button className="complete-button">Actions</Button>
                      </Dropdown>
                    </div>
                  ))
                ) : (
                  <Empty description="No announcement added" />
                )}
              </div>
            )}
            {(isAdding || editMode) && (
              <Form
                form={form}
                layout="vertical"
                onFinish={isAdding ? handleSubmit : handleEditAnnouncement}
              >
                <Form.Item
                  label="Subject"
                  name="title"
                  rules={[{ required: true, message: "Please enter the announcement subject" }]}
                >
                  <Input placeholder="Enter announcement" />
                </Form.Item>
                <Form.Item
                  label="Message"
                  name="message"
                  rules={[{ required: true, message: "Please enter the announcement message" }]}
                >
                  <Input placeholder="Enter message" />
                </Form.Item>
                <div className="buttons">
                  <Button type="default" onClick={handleCancel}>
                    Cancel
                  </Button>
                  &nbsp;&nbsp;
                  <Button
                    type="primary"
                    loading={submitting}
                    htmlType="submit"
                    disabled={submitting}
                  >
                    {submitting
                      ? isAdding
                        ? "Adding..."
                        : "Updating..."
                      : isAdding
                      ? "Add"
                      : "Update"}
                  </Button>
                </div>
              </Form>
            )}
          </>
        )}
      </div>
    </Card>
  );
}

export default Announcement;
